module.exports = __webpack_public_path__ + "assets/images/caixa-de-bombons_1564ae75362efd0392726f4cbb7a2139.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/paralelepipedo/caixa-de-bombons.png
// module id = 207
// module chunks = 0